import React, { useState } from "react";
import CityBox from "../components/dropbox/CityBox";
import CountBox from "../components/dropbox/CountBox";
import Datebox from "../components/dropbox/Datebox";
import CategoriesCarousel from "../components/layouts/Home/CategoriesCarousel";
import Commentbyother from "../components/layouts/Home/Commentbyother";
import Cooprate from "../components/layouts/Home/Cooprate";
import DemandedCity from "../components/layouts/Home/DemandedCity";
import FastReserve from "../components/layouts/Home/FastReserve";
import FastSearch from "../components/layouts/Home/FastSearch";
import Header from "../components/layouts/Home/Header";
import LuxePlace from "../components/layouts/Home/LuxePlace";
import Newscarousel from "../components/layouts/Home/Newscarousel";
import Popularcity from "../components/layouts/Home/PopularPlace";
import SpecialPlace from "../components/layouts/Home/SpecialPlace";
import SpecialTips from "../components/layouts/Home/SpecialTips";
import useFetch from "../hooks/useAxios";
import "react-loading-skeleton/dist/skeleton.css";
const Home = () => {
  const [dropbox, setDropbox] = useState(); //city //start //end //count
  const [infoHome, setinfoHome] = useState(); //city //start //end //count
  const apiGetHomeInfo = useFetch({
    method: "get",
    url: "api/home",
    noHeader: true,
    trigger: true,
    argFunc: res => setinfoHome(res.data)
  });
  return (
    <div onClick={() => setDropbox()}>
      <Header  dropbox={dropbox} setDropbox={setDropbox} />
{infoHome?.residences_with_special_discount.length !== 0 && <SpecialTips infoHome={infoHome}  />} 

     {infoHome?.fast_search?.length !== 0  && <FastSearch info={infoHome?.fast_search} /> }
      <DemandedCity infoHome={infoHome} />
    {infoHome?.instant_reserves.length !== 0 &&   <FastReserve infoHome={infoHome} />}
      <CategoriesCarousel />z
      <Popularcity infoHome={infoHome} />
      <Commentbyother />
      <SpecialPlace infoHome={infoHome} />
      <LuxePlace infoHome={infoHome} />
      <Cooprate />
      <Newscarousel />
      {/* 
    
    
     

    
    */}

      {/* <Datebox />
      <CountBox />
      <CityBox /> */}
    </div>
  );
};

export default Home;
